import React from 'react';
import { formatDate } from '~/util';

interface AnswerType {
    id: number;
    name: string;
    sub_sequence: number;
    value: string | number;
    date?: null | string;
}
interface QualitySubmitRowProps {
    qualityGapMeasure: QualityMeasureType;
    submissionAnswer?: SubmissionAnswerType;
}
export function QualitySubmitRow({ qualityGapMeasure, submissionAnswer }: QualitySubmitRowProps) {
    const answers: AnswerType[] = [];

    qualityGapMeasure.quality_measure_details?.forEach((detail) => {
        const answer = submissionAnswer?.metadata?.responses.find(
            (x) => detail.id === x.quality_measure_detail?.id
        );
        if (answer) {
            const obj: AnswerType = {
                id: detail.id,
                name: detail.name,
                sub_sequence: detail.sub_sequence!,
                value: answer.value,
            };
            const lookup = detail.lookup_metadata?.find(
                (look) => look.SupplementalDataValue === answer.value
            );
            if (lookup) obj.value = lookup.SupplementalDataValueDescription;
            try {
                obj.date = formatDate(answer.date);
            } catch (e) {
                obj.date = null;
            }
            answers.push(obj);
        }
    });

    return (
        <>
            <tr>
                <td colSpan={4}>
                    <span className="fw-bold ms-2">{qualityGapMeasure.name}</span>
                </td>
            </tr>
            {answers
                .sort((det1, det2) => det1.sub_sequence - det2.sub_sequence)
                .map((detail) => (
                    <tr key={detail.id}>
                        <td colSpan={2} className="col-gap-action-name">
                            <div className="ms-2">
                                <span>{detail.name}</span>
                            </div>
                        </td>
                        <td className="w-40 text-center">{detail.date}</td>
                        <td className="w-10 text-center">{detail.value}</td>
                    </tr>
                ))}
        </>
    );
}
